<template lang="html">
  <div class="stick-item">
    <div class="stick-item-left">
      <img v-lazy="user.avatar" alt="">
      <div class="stick-item-info"  @click="goDetails">
        <div class="stick-item-info-stick">
          <span v-if="getTags.length > 0" :class="{ label: true, quiz: !getTags.includes('公告') }">{{getTags[0]}}</span>
          <span class="stick-item-info-stick-title">{{title}}</span>
        </div>
        <div class="stick-item-info-bottom">
          <span>{{user.nickName}}</span>
          <!-- <span>V</span> -->
          <!-- <span class="vip">{{role}}</span> -->
          <span>{{createTime}}</span>
        </div>
      </div>
    </div>
    <div class="stick-item-right">
      <div class="stick-item-right-stick">
        <span v-if="isExcellent" class="label paste">精</span>
        <span v-if="isRecommend" class="label paste-stick">顶</span>
      </div>
        <div class="stick-item-right-bottom">
          <span class="icon iconfont">&#xe635;</span>
          <span>{{commentCount}}</span>
          <span class="icon iconfont">&#xe633;</span>
          <span>{{viewCount}}</span>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: [
    'item'
  ],
  data () {
    return {
      user: {
        nickName: '',
        avatar: ''
      },
      createTime: '',
      ...this.item
    }
  },
  mounted () {
    // console.log('this.props.item', this)
  },
  computed: {
    getTags () {
      return this.tags.map(item => item.title)
    }
  },
  methods: {
    goDetails () {
      let path = `details/${this.nid}`
      if (this.$route.path.indexOf('communication') === -1) {
        path = `communication/${path}`
      }
      this.$router.push(path)
    }
  }
}
</script>

<style lang="scss" scoped>
@import '../assets/font/iconfont.css';
.label {
  box-sizing: border-box;
  display: inline-block;
  height: 19px;
  line-height: 15px;
  padding: 0 2px;
  font-size: 13px;
  border: 1px solid #FF5722;
  background: none;
  color: #FF5722;
  white-space: nowrap;
  margin-right: 5px;
  border-radius: 2px;
}
.quiz {
  border: 1px solid #5FB878;
  background: none;
  color: #5FB878;
}
.stick-item {
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 76px;
  line-height: 22px;
  padding: 15px 10px;
  border-bottom: 1px dotted #e2e2e2;
  box-sizing: border-box;
  cursor: pointer;
  .stick-item-left {
    display: flex;
    flex-direction: row;
    align-items: center;
    box-sizing: border-box;
    width: calc(100% - 135px);
    img {
      width: 45px;
      height: 45px;
      flex-shrink: 0;
      margin-right: 15px;
      box-sizing: border-box;
    }
    .stick-item-info {
      width: 100%;
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      height: 45px;
      .stick-item-info-stick {
        width: 100%;
        white-space: nowrap;
        span {
          white-space: nowrap;
          display: inline-block;
        }
        .stick-item-info-stick-title {
          display: inline-block;
          // max-width: 100%;
          // overflow: hidden;
          // text-overflow: ellipsis;
        }
      }
      .stick-item-info-bottom {
        color: #999;
        font-size: 13px;
        line-height: 13px;
        white-space: nowrap;
        span {
          margin-right: 15px;
          white-space: nowrap;
        }
        .vip {
          height: 16px;
          line-height: 16px;
          padding: 0 3px;
          background-color: #FF5722;
          color: #fff;
          border-radius: 2px;
        }
      }
    }
  }
  .stick-item-right {
    height: 45px;
    position: relative;
    .stick-item-right-stick {
      .paste, .paste-stick {
        background-color: #FF5722;
        color: #fff;
        border-radius: 2px;
        margin-left: 5px;
        margin-right: 0;
      }
      .paste-stick {
        background-color: #000;
        border: 1px solid #000;
      }
    }
    .stick-item-right-bottom {
      display: inline-block;
      text-align: right;
      height: 16px;
      width: 120px;
      box-sizing: border-box;
      position: absolute;
      bottom: 0;
      right: 0;
      span {
        color: #999;
        font-size: 13px;
        padding-left: 4px;
        line-height: 13px;
        display: inline-block;
      }
      .icon {
        font-size: 16px;
        margin-left: 10px;
      }
    }
  }
}
</style>
